<div>
    <ngx-gallery [options]="galleryOptions" [images]="galleryImages"></ngx-gallery>
</div>
